import { render, staticRenderFns } from "./Employment.vue?vue&type=template&id=50ae9dec&scoped=true"
import script from "./Employment.vue?vue&type=script&setup=true&lang=js"
export * from "./Employment.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Employment.vue?vue&type=style&index=0&id=50ae9dec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ae9dec",
  null
  
)

export default component.exports